import React, { useState, useRef, useEffect } from "react";

// Array of logo data
const logos = [
  {
    href: "https://open.spotify.com/artist/27sXOIKT1m3Fm1zQ3e3a4e",
    src: "/assets/images/logo-spotify.png",
    alt: "Spotify",
  },
  {
    href: "https://music.apple.com/us/artist/marino-flores-y-su-estilo-sierre%C3%B1o/1648413464",
    src: "/assets/images/logo-apple-music.png",
    alt: "Apple Music",
  },
  {
    href: "https://music.amazon.com/artists/B0BHBY7R4K/marino-flores-y-su-estilo-sierre%25C3%25B1o",
    src: "/assets/images/logo-amazon-music.png",
    alt: "Amazon Music",
  },
  {
    href: "https://www.youtube.com/@marinofloresestilosierreño/featured",
    src: "/assets/images/logo-youtube.png",
    alt: "YouTube",
  },
  {
    href: "https://link.deezer.com/s/315HMPXGOUdvfL44D8WCv",
    src: "/assets/images/logo_deezer.png",
    alt: "Deezer",
  },
  {
    href: "https://tidal.com/browse/artist/34818797/",
    src: "/assets/images/logo_tidal.png",
    alt: "Tidal",
    className: "tidal-logo-link",
  },
];

const LogoScroller = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollerRef = useRef(null);

  // This effect sets up the IntersectionObserver
  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;

    // The observer will trigger when a logo is 51% visible
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Get the index from the element's data attribute
            const index = parseInt(entry.target.dataset.index, 10);
            setActiveIndex(index);
          }
        });
      },
      {
        root: scroller, // We are checking for intersection within the scroller itself
        threshold: 0.51, // Trigger when 51% of the item is visible
      }
    );

    // Tell the observer to watch each logo element
    const logoElements = scroller.querySelectorAll("a");
    logoElements.forEach((el) => observer.observe(el));

    // Cleanup function to stop observing when the component unmounts
    return () => logoElements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div className="streaming-logos-container">
      <div className="streaming-logos" ref={scrollerRef}>
        {logos.map((logo, index) => (
          // We add `data-index` so the observer knows which logo is which
          <a
            key={index}
            data-index={index}
            href={logo.href}
            target="_blank"
            rel="noopener noreferrer"
            className={logo.className || ""}
          >
            <img src={logo.src} alt={logo.alt} />
          </a>
        ))}
      </div>
      <div className="logo-pagination">
        {logos.map((_, index) => (
          <div
            key={index}
            className={`dot ${index === activeIndex ? "active" : ""}`}
          />
        ))}
      </div>
    </div>
  );
};

export default LogoScroller;
